import React, { useState, useEffect } from "react";
import { LoginPage } from "./components/LoginPage";
import { OverviewPage } from "./components/OverviewPage";
import { SlideshowPage } from "./components/SlideshowPage";

type Page =
  | { type: "login" }
  | { type: "overview" }
  | { type: "slideshow"; letter: string };

export function App() {
  const [page, setPage] = useState<Page>({ type: "login" });
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    fetch("/api/check-auth")
      .then((r) => r.json())
      .then((data) => {
        if (data.authenticated) {
          setPage({ type: "overview" });
        }
        setChecking(false);
      })
      .catch(() => setChecking(false));
  }, []);

  if (checking) {
    return <div className="loading">Laden...</div>;
  }

  switch (page.type) {
    case "login":
      return <LoginPage onLogin={() => setPage({ type: "overview" })} />;
    case "overview":
      return (
        <OverviewPage
          onSelectTray={(letter) =>
            setPage({ type: "slideshow", letter })
          }
          onLogout={() => {
            fetch("/api/logout").then(() => setPage({ type: "login" }));
          }}
        />
      );
    case "slideshow":
      return (
        <SlideshowPage
          letter={page.letter}
          onBack={() => setPage({ type: "overview" })}
        />
      );
  }
}
